"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4003],{

/***/ 12930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RX": function() { return /* binding */ staticImprovementMapSpanish; },
/* harmony export */   "tH": function() { return /* binding */ useIntlImprovements; },
/* harmony export */   "xZ": function() { return /* binding */ useIntlImprovementsMap; }
/* harmony export */ });
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_0__);

;
var savedLocale;
var CImprovements = [];
function useIntlImprovements() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useTranslations)("formRealestateFilters");
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedLocale !== locale) CImprovements = [];
  if (CImprovements.length) return CImprovements;
  CImprovements = [{
    value: 15,
    label: translation("balcony")
  }, {
    value: 16,
    label: translation("foyer")
  }, {
    value: 17,
    label: translation("livingRoom")
  }, {
    value: 18,
    label: translation("livingDiningRoom")
  }, {
    value: 19,
    label: translation("diningRoom")
  }, {
    value: 20,
    label: translation("room")
  }, {
    value: 21,
    label: translation("pantry")
  }, {
    value: 22,
    label: translation("kitchen")
  }, {
    value: 26,
    label: translation("cistern")
  }, {
    value: 27,
    label: translation("breakfastRoom")
  }, {
    value: 28,
    label: translation("studio")
  }, {
    value: 29,
    label: translation("familyRoom")
  }, {
    value: 31,
    label: translation("ladder")
  }, {
    value: 32,
    label: translation("elevator")
  }, {
    value: 33,
    label: translation("coveredTerrace")
  }, {
    value: 73,
    label: translation("terrace")
  }, {
    value: 74,
    label: translation("gazebo")
  }, {
    value: 76,
    label: translation("swimmingPool")
  }, {
    value: 80,
    label: translation("courtyard")
  }, {
    value: 85,
    label: translation("parking")
  }, {
    value: 86,
    label: translation("roofedParking")
  }, {
    value: 87,
    label: translation("mezzanine")
  }, {
    value: 89,
    label: translation("jacuzzi")
  }, {
    value: 90,
    label: translation("services")
  }, {
    value: 91,
    label: translation("washing")
  }, {
    value: 93,
    label: translation("telecable")
  }, {
    value: 94,
    label: translation("cornices")
  }, {
    value: 95,
    label: translation("gates")
  }, {
    value: 96,
    label: translation("waterTank")
  }, {
    value: 98,
    label: translation("well")
  }, {
    value: 99,
    label: translation("aC")
  }, {
    value: 100,
    label: translation("fans")
  }, {
    value: 102,
    label: translation("transferA")
  }, {
    value: 103,
    label: translation("inverter")
  }, {
    value: 104,
    label: translation("heater")
  }, {
    value: 105,
    label: translation("filters")
  }, {
    value: 106,
    label: translation("annexes")
  }, {
    value: 107,
    label: translation("phone")
  }, {
    value: 153,
    label: translation("grids")
  }, {
    value: 154,
    label: translation("powerPlant")
  }, {
    value: 155,
    label: translation("fullPowerPlant")
  }, {
    value: 241,
    label: translation("aCCentral")
  }, {
    value: 242,
    label: translation("aCPreinstalled")
  }, {
    value: 243,
    label: translation("aCSplit")
  }, {
    value: 244,
    label: translation("socialAreas")
  }, {
    value: 246,
    label: translation("janitor")
  }, {
    value: 247,
    label: translation("electricGate")
  }, {
    value: 248,
    label: translation("roofAccess")
  }, {
    value: 249,
    label: translation("commonBathroom")
  }, {
    value: 250,
    label: translation("garbageDuct")
  }, {
    value: 251,
    label: translation("locker")
  }, {
    value: 252,
    label: translation("escape")
  }, {
    value: 253,
    label: translation("gym")
  }, {
    value: 254,
    label: translation("activitiesRoom")
  }];
  savedLocale = locale;
  return CImprovements;
}
var savedMapLocale;
var CImprovementsMap = new Map();
function useIntlImprovementsMap() {
  var vals = useIntlImprovements();
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedMapLocale !== locale) CImprovementsMap.clear();
  if (CImprovementsMap.size === 0) vals.forEach(function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    return CImprovementsMap.set(value, label);
  });
  savedMapLocale = locale;
  return CImprovementsMap;
}
var staticImprovementMapSpanish = new Map([[15, "Balcón"], [16, "Recibidor"], [17, "Sala"], [18, "Sala/Comedor"], [19, "Comedor"], [20, "Estar"], [21, "Pantry"], [22, "Cocina"], [26, "Cisterna"], [27, "Desayunador"], [28, "Estudio"], [29, "Family Room"], [31, "Escaleras"], [32, "Ascensor"], [33, "Terraza techada"], [73, "Terraza"], [74, "Gazebo"], [76, "Piscina"], [80, "Patio"], [85, "Parqueo"], [86, "Parq. Techado"], [87, "Mezzanine"], [89, "Jacuzzi"], [90, "Servicio"], [91, "Lavado"], [93, "Telecable"], [94, "Cornisas"], [95, "Verjas"], [96, "Tinaco"], [98, "Pozo"], [99, "A/C"], [100, "Abanicos"], [102, "Transfer/A"], [103, "Inversor"], [104, "Calentador"], [105, "Filtros"], [106, "Anexos"], [107, "Teléfono"], [153, "Rejas"], [154, "Planta Eléctrica (Común)"], [155, "Planta Eléctrica Full"], [241, "A/C Central"], [242, "A/C Preinstalado"], [243, "A/C Split"], [244, "Areas sociales"], [246, "Conserje"], [247, "Portón Eléctrico"], [248, "Acceso a Techo"], [249, "Baño Común"], [250, "Ducto Basura"], [251, "Locker"], [252, "Esc. Emergencia"], [253, "Gimnasio"], [254, "Salon de Actividades"]]);

/***/ }),

/***/ 86465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pb": function() { return /* binding */ useIntlPropertyTypes; },
/* harmony export */   "Rl": function() { return /* binding */ CPropertyTypes; },
/* harmony export */   "j4": function() { return /* binding */ useIntlPropertyCollectionTypes; },
/* harmony export */   "xP": function() { return /* binding */ useIntlPropertyTypesMap; }
/* harmony export */ });
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_0__);

;
var savedLocale;
var CPropertyTypesArray = [];
function useIntlPropertyTypes() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useTranslations)("realestateList.typeFilters");
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedLocale !== locale) CPropertyTypesArray = [];
  if (CPropertyTypesArray.length) return CPropertyTypesArray;
  CPropertyTypesArray = [{
    id: 1,
    name: translation("apartment"),
    slug: "apartment"
  }, {
    id: 2,
    name: translation("house"),
    slug: "house"
  }, {
    id: 3,
    name: translation("commercialPremises"),
    slug: "comercial+site"
  }, {
    id: 4,
    name: translation("industrialSite"),
    slug: "industrial+site"
  }, {
    id: 5,
    name: translation("estate"),
    slug: "estate"
  }, {
    id: 6,
    name: translation("land"),
    slug: "land"
  }, {
    id: 7,
    name: translation("business"),
    slug: "office"
  }, {
    id: 8,
    name: translation("building"),
    slug: "building"
  }, {
    id: 9,
    name: translation("tourist"),
    slug: "turistic"
  }, {
    id: 10,
    name: translation("hotel"),
    slug: "hotel"
  }, {
    id: 12,
    name: translation("housePlot"),
    slug: "house+or+land"
  }, {
    id: 13,
    name: translation("buildingPlot"),
    slug: "building+or+land"
  }, {
    id: 14,
    name: translation("project"),
    slug: "project"
  }, {
    id: 15,
    name: translation("penthouse"),
    slug: "penthouse"
  }, {
    id: 16,
    name: translation("gasStation"),
    slug: "gasstation"
  }, {
    id: 17,
    name: translation("office"),
    slug: "office+site"
  }];
  return CPropertyTypesArray;
}
var savedMapLocale;
var propertyTypesSlugMap = new Map();
function useIntlPropertyTypesMap() {
  var vals = useIntlPropertyTypes();
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedMapLocale !== locale) propertyTypesSlugMap.clear();

  if (propertyTypesSlugMap.size === 0) {
    vals.forEach(function (el) {
      return propertyTypesSlugMap.set(el.slug, el);
    });
  }

  savedMapLocale = locale;
  return propertyTypesSlugMap;
}
function useIntlPropertyCollectionTypes() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useTranslations)("realestateList.typeFilters");
  var CPropertyCollection = [{
    id: 1,
    name: translation("apartment"),
    slug: "apartment"
  }, {
    id: 2,
    name: translation("house"),
    slug: "house"
  }, {
    id: 9,
    name: translation("tourist"),
    slug: "turistic"
  }, {
    id: 14,
    name: translation("project"),
    slug: "project"
  }, {
    id: 15,
    name: translation("penthouse"),
    slug: "penthouse"
  }];
  return CPropertyCollection;
}
var CPropertyTypes = [{
  id: 1,
  name: "Apartamento",
  plural: "Apartamentos",
  slug: "apartment"
}, {
  id: 2,
  name: "Casa",
  plural: "Casas",
  slug: "house"
}, {
  id: 3,
  name: "Local Comercial",
  plural: "Locales Comerciales",
  slug: "comercial+site"
}, {
  id: 4,
  name: "Nave Industrial",
  plural: "Naves Industriales",
  slug: "industrial+site"
}, {
  id: 5,
  name: "Finca",
  plural: "Fincas",
  slug: "estate"
}, {
  id: 6,
  name: "Terreno",
  plural: "Terrenos",
  slug: "land"
}, {
  id: 7,
  name: "Negocio",
  plural: "Negocios",
  slug: "office"
}, {
  id: 8,
  name: "Edificio",
  plural: "Edificios",
  slug: "building"
}, {
  id: 9,
  name: "Turístico",
  plural: "Turísticos",
  slug: "turistic"
}, {
  id: 10,
  name: "Hotel",
  plural: "Hoteles",
  slug: "hotel"
}, {
  id: 12,
  name: "Casa o Solar",
  plural: "Casas o Solares",
  slug: "house+or+land"
}, {
  id: 13,
  name: "Edificio o Solar",
  plural: "Edificios o Solares",
  slug: "building+or+land"
}, {
  id: 14,
  name: "Proyecto",
  plural: "Proyectos",
  slug: "project"
}, {
  id: 15,
  name: "Penthouse",
  plural: "Penthouses",
  slug: "penthouse"
}, {
  id: 16,
  name: "Estación de Combustible",
  plural: "Estaciones de Combustible",
  slug: "gasstation"
}, {
  id: 17,
  name: "Local de Oficina",
  plural: "Locales de Oficina",
  slug: "office+site"
}];

/***/ }),

/***/ 31248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y_": function() { return /* binding */ parseRealestateFiltersToUrl; },
  "Ym": function() { return /* binding */ parseUrlToRealestateFilters; }
});

// UNUSED EXPORTS: validatePriceRange

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./shared/models/const/improvements.conts.ts
var improvements_conts = __webpack_require__(12930);
;// CONCATENATED MODULE: ./shared/models/functions/price-range-param.helper.ts
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Para venta:
// Dolares
//     Bajo costo: $40,000 a $88,888
//     Moderado: $88,889 a $150,000
//     Moderado-Alto: $150,001 a $250,000
//     Alto: $250,001 a $400,000
//     Premium: $400,001 a $599,999
//     Colección o lujo: $600,000 en adelante
// Pesos
//     Bajo costo (BC): RD$ 2,160,000 a RD$ 4,799,952
//     Moderado (MD): RD$ 4,799,953 a RD$ 8,100,000
//     Moderado-Alto (MA): RD$ 8,100,001 a RD$ 13,500,054
//     Alto (AT): RD$ 13,500,055 a RD$ 21,600,000
//     Premium (PM): RD$ 21,600,001 a RD$ 32,399,946
//     Colección o lujo (CL): RD$ 32,400,000 en adelante
// Estos son los valores que se enviaran dependiendo en que renglón caen
//     Bajo costo: BC
//     Moderado: MD
//     Moderado-Alto: MA
//     Alto: AT
//     Premium: PM
//     Colección o lujo: CL
// Enviar parametro: 
// mm={tipo_perfil} cuando sea asignado el precio minimo
// mma={tipo_perfil} cuando sea asignado el precio maximo
// Alquiler
//     Bajo costo (BC): $250 a $500
//     Moderado (MD): $501 a $1000
//     Moderado-Alto (MA): $1001 a $1500
//     Alto (AT): $1501 a $2000
//     Premium (PM): $2001 a $2500
//     Colección o lujo (CL): $2501 en adelante
//     Bajo costo (BC): RD$ 13,750 a RD$ 27,500
//     Moderado (MD): RD$ 27,501 a RD$ 55,000
//     Moderado-Alto (MA): RD$ 55,001 a RD$ 82,500
//     Alto (AT): RD$ 82,501 a RD$ 110,000
//     Premium (PM): RD$ 110,001 a RD$ 137,500
//     Colección o lujo (CL): RD$ 137,501 en adelante
// Estos son los valores que se enviaran dependiendo en que renglón caen
//     Bajo costo: ABC
//     Moderado: AMD
//     Moderado-Alto: AMA
//     Alto: AAT
//     Premium: APM
//     Colección o lujo: ACL
// Enviar parámetro: 
// mm={tipo_perfil} cuando sea asignado el precio minimo
// mma={tipo_perfil} cuando sea asignado el precio maximo
var priceRanges = {
  sale: {
    us: [{
      min: 40000,
      category: 'bc'
    }, {
      min: 88889,
      category: 'md'
    }, {
      min: 150001,
      category: 'ma'
    }, {
      min: 250001,
      category: 'at'
    }, {
      min: 400001,
      category: 'pm'
    }, {
      min: 600000,
      category: 'cl'
    }],
    rd: [{
      min: 2160000,
      category: 'bc'
    }, {
      min: 4799953,
      category: 'md'
    }, {
      min: 8100001,
      category: 'ma'
    }, {
      min: 13500055,
      category: 'at'
    }, {
      min: 21600001,
      category: 'pm'
    }, {
      min: 32400000,
      category: 'cl'
    }],
    "default": "sp"
  },
  lease: {
    us: [{
      min: 250,
      category: 'abc'
    }, {
      min: 501,
      category: 'amd'
    }, {
      min: 1001,
      category: 'ama'
    }, {
      min: 1501,
      category: 'aat'
    }, {
      min: 2001,
      category: 'apm'
    }, {
      min: 2501,
      category: 'acl'
    }],
    rd: [{
      min: 13750,
      category: 'abc'
    }, {
      min: 27501,
      category: 'amd'
    }, {
      min: 55001,
      category: 'ama'
    }, {
      min: 82501,
      category: 'aat'
    }, {
      min: 110001,
      category: 'apm'
    }, {
      min: 137501,
      category: 'acl'
    }],
    "default": "asp"
  }
};
var lastValidValue = "";
function getPriceRangeParam(_ref) {
  var amountMin = _ref.amountMin,
      amountMax = _ref.amountMax,
      currencyType = _ref.currencyType,
      businessTypes = _ref.businessTypes;
  var resultMax = null;
  var resultMin = null;
  var resultParams = "";
  if (!amountMax && !amountMin) return lastValidValue;
  if (amountMax && amountMin && +amountMax < +amountMin) return lastValidValue;

  try {
    var _resultMin, _resultMax, _resultParams;

    var prices = priceRanges[businessTypes];

    var _iterator = _createForOfIteratorHelper(prices[currencyType]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var range = _step.value;

        if (amountMin) {
          if (+amountMin >= range.min) {
            resultMin = range.category;
          }
        }

        if (amountMax) {
          if (+amountMax >= range.min) {
            resultMax = range.category;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    resultParams = "".concat(amountMin ? "&mm=" + ((_resultMin = resultMin) !== null && _resultMin !== void 0 ? _resultMin : prices["default"]) : "") + "".concat(amountMax ? "&mma=" + ((_resultMax = resultMax) !== null && _resultMax !== void 0 ? _resultMax : prices["default"]) : "");
    lastValidValue = (_resultParams = resultParams) !== null && _resultParams !== void 0 ? _resultParams : lastValidValue;
    return lastValidValue;
  } catch (error) {
    return lastValidValue;
  }
}
// EXTERNAL MODULE: ./shared/models/functions/query-string-helper.ts
var query_string_helper = __webpack_require__(23622);
;// CONCATENATED MODULE: ./shared/models/functions/realestate-filters-helper.ts



var _excluded = ["city", "locations", "typeProperty", "sector", "onlyUnits"],
    _excluded2 = ["city", "locations", "sector", "typeProperty"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var parseRealestateFiltersToUrl = function parseRealestateFiltersToUrl(values) {
  var _locations$at, _rest$improvements;

  var city = values.city,
      locations = values.locations,
      _values$typeProperty = values.typeProperty,
      typeProperty = _values$typeProperty === void 0 ? [] : _values$typeProperty,
      sector = values.sector,
      onlyUnits = values.onlyUnits,
      rest = (0,objectWithoutProperties/* default */.Z)(values, _excluded);

  var formattedUrl = (0,query_string_helper/* queryFormatter */.Bt)(_objectSpread(_objectSpread({}, rest), validatePriceRange(rest)));
  var typePropertyFilters = getTypeProperty(typeProperty);
  var locationsFilters = serializeArrayOfObject(locations);
  var SectorFilters = serializeArrayOfObject(sector);
  var ciudad = locations === null || locations === void 0 ? void 0 : (_locations$at = locations.at(0)) === null || _locations$at === void 0 ? void 0 : _locations$at.description;
  var sectores = sector === null || sector === void 0 ? void 0 : sector.map(function (sector) {
    return sector.description;
  }).join('|');
  var complexFilters = (0,query_string_helper/* queryFormatter */.Bt)({
    typeProperty: typePropertyFilters,
    locations: locationsFilters,
    sector: SectorFilters,
    onlyUnits: onlyUnits
  });
  if (complexFilters) formattedUrl += '&' + complexFilters; //Add cosmetic/stats params (should be removed in parseUrlToRealestateFilters)

  if (ciudad) formattedUrl += '&ciudad=' + ciudad;
  if (sectores) formattedUrl += '&sectores=' + sectores;
  if (onlyUnits !== null && onlyUnits !== void 0 && onlyUnits.length && onlyUnits.length < 2) formattedUrl += formatOnlyUnitsParams(onlyUnits);
  if (rest.amountMax || rest.amountMin) formattedUrl += getPriceRangeParam(values);
  if ((_rest$improvements = rest.improvements) !== null && _rest$improvements !== void 0 && _rest$improvements.length) formattedUrl += formatImprovementsParams(rest.improvements);
  return formattedUrl;
};
var lastValidPriceRange = {};
var validatePriceRange = function validatePriceRange(_ref) {
  var amountMax = _ref.amountMax,
      amountMin = _ref.amountMin;
  if (amountMax && amountMin && +amountMax < +amountMin) return lastValidPriceRange;
  lastValidPriceRange = {
    amountMax: amountMax,
    amountMin: amountMin
  };
  return lastValidPriceRange;
};

function formatOnlyUnitsParams(onlyUnits) {
  return '&tipo_construccion=' + (onlyUnits[0] === 'true' ? 'construida' : 'en construccion');
}

function formatImprovementsParams(improvements) {
  return "&amenidades=" + improvements.map(function (imp) {
    return improvements_conts/* staticImprovementMapSpanish.get */.RX.get(+imp);
  }).join("|");
}

var parseUrlToRealestateFilters = function parseUrlToRealestateFilters(values) {
  var city = values.city,
      locations = values.locations,
      sector = values.sector,
      _values$typeProperty2 = values.typeProperty,
      typeProperty = _values$typeProperty2 === void 0 ? [] : _values$typeProperty2,
      rest = (0,objectWithoutProperties/* default */.Z)(values, _excluded2);

  var locationFilters = serializeArrayOfString(locations);
  var sectorFilters = serializeArrayOfString(sector); //Remove cosmetic/stats params

  ['ciudad', 'sectores', 'tipo_construccion', 'mm', 'mma', 'amenidades'].map(function (prop) {
    return delete rest[prop];
  });
  return _objectSpread({
    locations: locationFilters,
    typeProperty: typeProperty,
    sector: sectorFilters
  }, rest);
}; // We are serializing Array of object into this kind of notation
// Array[] = ["key-value&"]
// the & is just a delimiter

function serializeArrayOfObject() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newArray = [];

  var _loop = function _loop(index) {
    var element = array[index];

    var _string = Object.keys(element).reduce(function (prev, current) {
      return prev + "".concat(current, "-").concat(element[current], "&");
    }, "");

    newArray.push(_string);
  };

  for (var index = 0; index < array.length; index++) {
    _loop(index);
  }

  return newArray;
} // setting back the array of string we get from the url
// thanks to the previous function


function serializeArrayOfString() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newArray = [];

  var _loop2 = function _loop2(index) {
    var element = array[index];
    var keyValues = element.split("&").filter(function (e) {
      return e != "";
    });
    var obj = {};
    keyValues.forEach(function (keyValue) {
      var _keyValue$split = keyValue.split("-"),
          _keyValue$split2 = (0,slicedToArray/* default */.Z)(_keyValue$split, 2),
          key = _keyValue$split2[0],
          value = _keyValue$split2[1];

      var finalValue = value;

      if (value == "true" || value == "false") {
        finalValue = value == "true";
      }

      obj[key] = finalValue;
    });
    newArray.push(obj);
  };

  for (var index = 0; index < array.length; index++) {
    _loop2(index);
  }

  return newArray;
} // function transformSpecialFilters(value: string) {
//   if (!value.includes(">") && parseInt(value) >= 5) {
//     return ">4";
//   }
//   return value;
// }
// function concatSpecialFilters(value: string, property: string) {
//   if (value) {
//     return "&" + queryFormatter({ [property]: transformSpecialFilters(value) });
//   }
//   return "";
// }


function getTypeProperty() {
  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return types.map(function (item) {
    if (item !== null && item !== void 0 && item.slug) {
      return item.slug;
    }

    if (item !== null && item !== void 0 && item.value) {
      return item.value;
    }

    if (typeof item === "string") {
      return item;
    }

    return "";
  });
}

/***/ })

}]);